import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconMinus = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 2" size={size} {...props}>
        <StyledPath
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M1.375 1.019h11.25"
        />
    </StyledSvg>
);
